var path = 'src/app/patients/transplants/transplants.html';
var html = "<h1 class=page-header>Kidney Transplants</h1> <div transplants-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/transplants/transplants.html
 ** module id = 605
 ** module chunks = 0
 **/